export const generateStars = (count: number) => {
  return Array.from({ length: count }, (_, i) => {
    return i + 1;
  });
};
